.alert {
  margin-top: 16px;
  margin-bottom: 16px;
}

.description {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* GH #2785: a version row wraps its actions onto a second line when they don't fit beside the date */
.row {
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
}

.actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
